import { render, staticRenderFns } from "./ruleMatching.vue?vue&type=template&id=0755217a&scoped=true&"
import script from "./ruleMatching.vue?vue&type=script&lang=js&"
export * from "./ruleMatching.vue?vue&type=script&lang=js&"
import style0 from "./ruleMatching.vue?vue&type=style&index=0&id=0755217a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0755217a",
  null
  
)

export default component.exports